import fetchApi from "../fetchApi";
// A migrated (iip_user) role is assigned via SetUserRoles, so the profile update
// must NOT write users.role for them (it would de-migrate them to a static role).
// A LEGACY user's role is still assigned the classic way: pass `role` (the legacy
// role name) and it is written to users.role. Omit `role` for iip_user edits.
export const UpdateUser = async (
  id,
  firstName,
  lastName,
  email,
  offices,
  phone,
  role
) => {
  const body = {
    first_name: firstName,
    last_name: lastName,
    email: email,
    office_ids: offices,
    phone_number: phone,
  };
  if (role) {
    body.role = role;
  }

  const options = {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(body),
    redirect: "follow",
  };

  return await fetchApi(`users/${id}`, options);
};
